export const CUSTOMER_APPLICATION_STEPS = {
  1: { label: "1. Personal information" },
  2: { label: "2. Personal information" },
  3: { label: "3. Personal information" },
  4: { label: "4. Employment" },
  5: { label: "5. Financial information" },
  6: { label: "6. Stock & Bond Experience" },
  7: { label: "7. Regulatory information" },
  8: { label: "8. Trading Permissions" },
};

const stepArray = Object.keys(CUSTOMER_APPLICATION_STEPS).map((a) => Number(a) as CustomerApplicationStepNumber);

export type CustomerApplicationStepNumber = keyof typeof CUSTOMER_APPLICATION_STEPS;
export const hasCustomerApplicationStepNext = (step: CustomerApplicationStepNumber) => Number(step) < 8;
export const getCustomerApplicationNextStep = (step: CustomerApplicationStepNumber) =>
  stepArray[stepArray.indexOf(step) + 1];
